import { createContext, useContext } from 'react'

// Menyvalgene (favorittene og de sammenlagte gruppene) deles av menyen og
// stjerna i sideoverskriften (PageHeader). Utenfor DashboardLayout, for
// eksempel i testene av en enkelt side, finnes ingen kontekst, og stjerna
// vises ikke.
export const MenyvalgKontekst = createContext(null)

export const useMenyvalgKontekst = () => useContext(MenyvalgKontekst)
